import React from 'react'
import GenericButton from '../GenericButton'
import { gettext } from 'ttag'

interface OwnProps {
  children?: React.ReactNode
  onPress?: (...args: any[]) => any
}

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
type Props = OwnProps & typeof WaterLevel.defaultProps

// @ts-expect-error ts-migrate(2339) FIXME: Property 'onLongPress' does not exist on type 'Pro... Remove this comment to see the full error message
export default function WaterLevel ({ onPress, onLongPress, on, offline, text, connectionStatus, hide, hideButtonPress, inverted }: Props) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  const finalOn = inverted ? !on : on

  return (
    <GenericButton
      icon="water"
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ icon: string; text: any; status: string; i... Remove this comment to see the full error message
      text={text}
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      status={finalOn ? gettext('Detected') : ''}
      iconOnColor="#6699FF"
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      textColor={finalOn ? { color: '#6699FF', fontWeight: 'bold' } : null}
      on={finalOn}
      onLongPress={onLongPress}
      connectionStatus={connectionStatus}
      offline={offline}
      onPress={onPress}
      hide={hide}
      hideButtonPress={hideButtonPress}
    />
  )
}

WaterLevel.defaultProps = {
  children: null,
  onPress: () => { }
}
